import union from 'lodash/union';

export const types = {
  PULL_REQUEST_REQUEST: 'PULL_REQUESTS/PULL_REQUEST_REQUEST',
  PULL_REQUEST_SUCCESS: 'PULL_REQUESTS/PULL_REQUEST_SUCCESS',
  PULL_REQUEST_FAILURE: 'PULL_REQUESTS/PULL_REQUEST_FAILURE',

  PULL_REQUEST_COMMITS_REQUEST: 'PULL_REQUESTS/PULL_REQUEST_COMMITS_REQUEST',
  PULL_REQUEST_COMMITS_SUCCESS: 'PULL_REQUESTS/PULL_REQUEST_COMMITS_SUCCESS',
  PULL_REQUEST_COMMITS_FAILURE: 'PULL_REQUESTS/PULL_REQUEST_COMMITS_FAILURE',

  PULL_REQUEST_EVENTS_REQUEST: 'PULL_REQUESTS/PULL_REQUEST_EVENTS_REQUEST',
  PULL_REQUEST_EVENTS_SUCCESS: 'PULL_REQUESTS/PULL_REQUEST_EVENTS_SUCCESS',
  PULL_REQUEST_EVENTS_FAILURE: 'PULL_REQUESTS/PULL_REQUEST_EVENTS_FAILURE',

  PULL_REQUEST_COMMENTS_REQUEST: 'PULL_REQUESTS/PULL_REQUEST_COMMENTS_REQUEST',
  PULL_REQUEST_COMMENTS_SUCCESS: 'PULL_REQUESTS/PULL_REQUEST_COMMENTS_SUCCESS',
  PULL_REQUEST_COMMENTS_FAILURE: 'PULL_REQUESTS/PULL_REQUEST_COMMENTS_FAILURE',

  PULL_REQUEST_COMMENT_SNIPPETS_REQUEST:
    'PULL_REQUESTS/PULL_REQUEST_COMMENT_SNIPPETS_REQUEST',
  PULL_REQUEST_COMMENT_SNIPPETS_SUCCESS:
    'PULL_REQUESTS/PULL_REQUEST_COMMENT_SNIPPETS_SUCCESS',
  PULL_REQUEST_COMMENT_SNIPPETS_FAILURE:
    'PULL_REQUESTS/PULL_REQUEST_COMMENT_SNIPPETS_FAILURE',

  PULL_REQUEST_REVIEWS_REQUEST: 'PULL_REQUESTS/PULL_REQUEST_REVIEWS_REQUEST',
  PULL_REQUEST_REVIEWS_SUCCESS: 'PULL_REQUESTS/PULL_REQUEST_REVIEWS_SUCCESS',
  PULL_REQUEST_REVIEWS_FAILURE: 'PULL_REQUESTS/PULL_REQUEST_REVIEWS_FAILURE',

  PULL_REQUEST_STATIC_JOB_REQUEST:
    'PULL_REQUESTS/PULL_REQUEST_STATIC_JOB_REQUEST',
  PULL_REQUEST_STATIC_JOB_FAILURE:
    'PULL_REQUESTS/PULL_REQUEST_STATIC_JOB_FAILURE',
  PULL_REQUEST_STATIC_JOB_SUCCESS:
    'PULL_REQUESTS/PULL_REQUEST_STATIC_JOB_SUCCESS',

  RESTART_STATIC_JOB_REQUEST: 'PULL_REQUESTS/RESTART_STATIC_JOB_REQUEST',
  RESTART_STATIC_JOB_FAILURE: 'PULL_REQUESTS/RESTART_STATIC_JOB_FAILURE',
  RESTART_STATIC_JOB_SUCCESS: 'PULL_REQUESTS/RESTART_STATIC_JOB_SUCCESS',

  PULL_REQUEST_STATIC_TASK_REQUEST:
    'PULL_REQUESTS/PULL_REQUEST_STATIC_TASK_REQUEST',
  PULL_REQUEST_STATIC_RESULTS_REQUEST:
    'PULL_REQUESTS/PULL_REQUEST_STATIC_RESULTS_REQUEST',
  PULL_REQUEST_STATIC_RESULTS_FAILURE:
    'PULL_REQUESTS/PULL_REQUEST_STATIC_RESULTS_FAILURE',
  PULL_REQUEST_STATIC_RESULTS_SUCCESS:
    'PULL_REQUESTS/PULL_REQUEST_STATIC_RESULTS_SUCCESS',

  PULL_REQUEST_STATIC_RESULTS_SNIPPETS_REQUEST:
    'PULL_REQUESTS/PULL_REQUEST_STATIC_RESULTS_SNIPPETS_REQUEST',
  PULL_REQUEST_STATIC_RESULTS_SNIPPETS_FAILURE:
    'PULL_REQUESTS/PULL_REQUEST_STATIC_RESULTS_SNIPPETS_FAILURE',
  PULL_REQUEST_STATIC_RESULTS_SNIPPETS_SUCCESS:
    'PULL_REQUESTS/PULL_REQUEST_STATIC_RESULTS_SNIPPETS_SUCCESS',

  PULL_REQUEST_STATIC_TASK_ERROR_LOG_REQUEST:
    'PULL_REQUESTS/STATIC_TASK_ERROR_LOG_REQUEST',
  PULL_REQUEST_STATIC_TASK_ERROR_LOG_FAILURE:
    'PULL_REQUESTS/STATIC_TASK_ERROR_LOG_FAILURE',
  PULL_REQUEST_STATIC_TASK_ERROR_LOG_SUCCESS:
    'PULL_REQUESTS/STATIC_TASK_ERROR_LOG_SUCCESS',

  PULL_REQUEST_DIFF_REQUEST: 'PULL_REQUESTS/PULL_REQUEST_DIFF_REQUEST',
  PULL_REQUEST_DIFF_SUCCESS: 'PULL_REQUESTS/PULL_REQUEST_DIFF_SUCCESS',
  PULL_REQUEST_DIFF_FAILURE: 'PULL_REQUESTS/PULL_REQUEST_DIFF_FAILURE',

  PULL_REQUEST_COLLAPSE_ELEMENT_REQUEST:
    'PULL_REQUESTS/PULL_REQUEST_COLLAPSE_ELEMENT_REQUEST',
  PULL_REQUEST_COLLAPSED_COMMENTS_SUCCESS:
    'PULL_REQUESTS/PULL_REQUEST_COLLAPSED_COMMENTS_SUCCESS',
  PULL_REQUEST_COLLAPSED_STATIC_RESULTS_SUCCESS:
    'PULL_REQUESTS/PULL_REQUEST_COLLAPSED_STATIC_RESULTS_SUCCESS',
  PULL_REQUEST_EXPAND_ELEMENT_REQUEST:
    'PULL_REQUESTS/PULL_REQUEST_EXPAND_ELEMENT_REQUEST',
  PULL_REQUEST_EXPAND_COMMENTS_SUCCESS:
    'PULL_REQUESTS/PULL_REQUEST_EXPAND_COMMENTS_SUCCESS',
  PULL_REQUEST_EXPAND_STATIC_RESULTS_SUCCESS:
    'PULL_REQUESTS/PULL_REQUEST_EXPAND_STATIC_RESULTS_SUCCESS',
  PULL_REQUEST_SNOOZE_RESULT_REQUEST:
    'PULL_REQUESTS/PULL_REQUEST_SNOOZE_RESULT_REQUEST',
  PULL_REQUEST_SNOOZE_RESULT_SUCCESS:
    'PULL_REQUESTS/PULL_REQUEST_SNOOZE_RESULT_SUCCESS',
  PULL_REQUEST_SNOOZE_RESULT_FAILURE:
    'PULL_REQUESTS/PULL_REQUEST_SNOOZE_RESULT_FAILURE',
  PULL_REQUEST_UNDO_SNOOZE_RESULT_REQUEST:
    'PULL_REQUESTS/PULL_REQUEST_UNDO_SNOOZE_RESULT_REQUEST',
  PULL_REQUEST_UNDO_SNOOZE_RESULT_SUCCESS:
    'PULL_REQUESTS/PULL_REQUEST_UNDO_SNOOZE_RESULT_SUCCESS',
  PULL_REQUEST_UNDO_SNOOZE_RESULT_FAILURE:
    'PULL_REQUESTS/PULL_REQUEST_UNDO_SNOOZE_RESULT_FAILURE',
  PULL_REQUEST_SNOOZED_RESULTS_REQUEST:
    'PULL_REQUESTS/PULL_REQUEST_SNOOZED_RESULTS_REQUEST',
  PULL_REQUEST_SNOOZED_RESULTS_SUCCESS:
    'PULL_REQUESTS/PULL_REQUEST_SNOOZED_RESULTS_SUCCESS',
  PULL_REQUEST_SNOOZED_RESULTS_FAILURE:
    'PULL_REQUESTS/PULL_REQUEST_SNOOZED_RESULTS_FAILURE',

  REREQUEST_REVIEW_REQUEST: 'PULL_REQUESTS/REREQUEST_REVIEW_REQUEST',
  REREQUEST_REVIEW_SUCCESS: 'PULL_REQUESTS/REREQUEST_REVIEW_SUCCESS',
  REREQUEST_REVIEW_FAILURE: 'PULL_REQUESTS/REREQUEST_REVIEW_FAILURE',
};

export const initialState = {
  error: null,
  errorCode: null,
  isLoading: false,
  isLoadingCommits: false,
  isLoadingComments: false,
  isLoadingReviews: false,
  isLoadingDiff: false,
  isLoadingStaticJob: false,
  byKey: {}, // individual pull requests by their {providerId}:{orgSlug}:{projectName}:{reviewNumber} key
  commitsByKey: {}, // sets of commits by their {providerId}:{orgSlug}:{projectName}:{reviewNumber} key
  eventsByPullRequestUUID: {}, // sets of events by their pullRequestUUID key
  commentsByKey: {}, // sets of comments by their {providerId}:{orgSlug}:{projectName}:{reviewNumber} key
  commentSnippetsByKey: {}, // sets of comment snippets by their {providerId}:{orgSlug}:{projectName}:{reviewNumber} key
  reviewsByKey: {}, // sets of reviews by their {providerId}:{orgSlug}:{projectName}:{reviewNumber} key
  staticJobsByKey: {}, // sets of static results by their {providerId}:{orgSlug}:{projectName}:{reviewNumber} key
  staticResultsByKey: {}, // sets of static results by their {providerId}:{orgSlug}:{projectName}:{reviewNumber} key
  staticResultsSnippetsByKey: {}, // sets of snippets for static results by their {providerId}:{orgSlug}:{projectName}:{reviewNumber} key
  staticTaskErrorLogsByKey: {}, // sets of static task error logs by their {jobUUID}:{engine} key
  diffByKey: {}, // sets of diffs by their {providerId}:{orgSlug}:{projectName}:{reviewNumber} key
  collapsedComments: {}, // sets of collapsed comments by their {providerId}:{orgSlug}:{projectName}:{path}:{commentUUID} key
  collapsedStaticResults: {}, // sets of collapsed static results by their {providerId}:{orgSlug}:{projectName}:{path}:{fingerprint} key
  snoozedResultsByKey: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.PULL_REQUEST_SUCCESS: {
      const { key, data } = action;
      return {
        ...state,
        isLoading: false,
        byKey: {
          ...state.byKey,
          [key]: {
            ...data,
            review: {
              ...data.review,
              created_at: data.review ? new Date(data.review.created_at) : null,
            },
          },
        },
      };
    }
    case types.PULL_REQUEST_REQUEST: {
      return { ...state, isLoading: true, error: null, errorCode: null };
    }
    case types.PULL_REQUEST_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    }

    case types.PULL_REQUEST_COMMITS_SUCCESS: {
      const { key, data } = action;
      return {
        ...state,
        isLoadingCommits: false,
        commitsByKey: {
          ...state.commitsByKey,
          [key]: data.map((commit) => {
            return {
              ...commit,
              created_at: new Date(commit.created_at),
            };
          }),
        },
      };
    }
    case types.PULL_REQUEST_COMMITS_REQUEST: {
      return { ...state, isLoadingCommits: true, error: null, errorCode: null };
    }
    case types.PULL_REQUEST_COMMITS_FAILURE: {
      return {
        ...state,
        isLoadingCommits: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    }

    case types.PULL_REQUEST_EVENTS_SUCCESS: {
      const { pullRequestUUID, data } = action;
      return {
        ...state,
        isLoadingEvents: false,
        eventsByPullRequestUUID: {
          ...state.eventsByPullRequestUUID,
          [pullRequestUUID]: data.map((event) => {
            return {
              ...event,
              created_at: new Date(event.created_at),
            };
          }),
        },
      };
    }
    case types.PULL_REQUEST_EVENTS_REQUEST: {
      return { ...state, isLoadingEvents: true, error: null, errorCode: null };
    }
    case types.PULL_REQUEST_EVENTS_FAILURE: {
      return {
        ...state,
        isLoadingEvents: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    }

    case types.PULL_REQUEST_COMMENTS_SUCCESS: {
      const { key, data } = action;
      return {
        ...state,
        isLoadingComments: false,
        commentsByKey: {
          ...state.commentsByKey,
          [key]: data.map((comment) => {
            return {
              ...comment,
              created_at: new Date(comment.created_at),
            };
          }),
        },
      };
    }

    case types.PULL_REQUEST_COMMENTS_REQUEST: {
      return {
        ...state,
        isLoadingComments: true,
        error: null,
        errorCode: null,
      };
    }
    case types.PULL_REQUEST_COMMENTS_FAILURE: {
      return {
        ...state,
        isLoadingComments: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    }

    case types.PULL_REQUEST_COMMENT_SNIPPETS_SUCCESS: {
      const { key, data } = action;
      return {
        ...state,
        commentSnippetsByKey: {
          ...state.commentSnippetsByKey,
          [key]: data,
        },
      };
    }
    case types.PULL_REQUEST_COMMENT_SNIPPETS_REQUEST: {
      return { ...state, error: null, errorCode: null };
    }
    case types.PULL_REQUEST_COMMENT_SNIPPETS_FAILURE: {
      return {
        ...state,
        error: action.error,
        errorCode: action.errorCode,
      };
    }

    case types.PULL_REQUEST_REVIEWS_SUCCESS: {
      const { key, data } = action;
      return {
        ...state,
        isLoadingReviews: false,
        reviewsByKey: {
          ...state.reviewsByKey,
          [key]: data.map((review) => {
            return {
              ...review,
              created_at: new Date(review.created_at),
              updated_at: new Date(review.updated_at),
            };
          }),
        },
      };
    }
    case types.PULL_REQUEST_REVIEWS_REQUEST: {
      return { ...state, isLoadingReviews: true, error: null, errorCode: null };
    }
    case types.PULL_REQUEST_REVIEWS_FAILURE: {
      return {
        ...state,
        isLoadingReviews: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    }

    case types.PULL_REQUEST_STATIC_JOB_SUCCESS: {
      const { key, job } = action;
      return {
        ...state,
        staticJobsByKey: {
          ...state.staticJobsByKey,
          [key]: job,
        },
        isLoadingStaticJob: false,
      };
    }
    case types.PULL_REQUEST_STATIC_JOB_REQUEST: {
      return {
        ...state,
        error: null,
        errorCode: null,
        isLoadingStaticJob: true,
      };
    }
    case types.PULL_REQUEST_STATIC_JOB_FAILURE: {
      return {
        ...state,
        error: action.error,
        errorCode: action.errorCode,
        isLoadingStaticJob: false,
      };
    }

    case types.PULL_REQUEST_STATIC_RESULTS_SNIPPETS_SUCCESS: {
      const { key, data } = action;
      return {
        ...state,
        staticResultsSnippetsByKey: {
          ...state.staticResultsSnippetsByKey,
          [key]: {
            ...(state.staticResultsSnippetsByKey[key] || {}),
            ...(data || {}),
          },
        },
      };
    }
    case types.PULL_REQUEST_STATIC_RESULTS_SNIPPETS_REQUEST: {
      return { ...state, error: null, errorCode: null };
    }
    case types.PULL_REQUEST_STATIC_RESULTS_SNIPPETS_FAILURE: {
      return {
        ...state,
        error: action.error,
        errorCode: action.errorCode,
      };
    }

    case types.RESTART_STATIC_JOB_REQUEST: {
      return {
        ...state,
        error: null,
        errorCode: null,
        isLoading: true,
        isLoadingStaticJob: true,
      };
    }
    case types.RESTART_STATIC_JOB_FAILURE: {
      return {
        ...state,
        error: action.error,
        errorCode: action.errorCode,
        isLoading: false,
        isLoadingStaticJob: false,
      };
    }
    case types.RESTART_STATIC_JOB_SUCCESS: {
      return { ...state, isLoading: false };
    }

    case types.REREQUEST_REVIEW_REQUEST: {
      return {
        ...state,
        error: null,
        errorCode: null,
        isLoading: true,
      };
    }
    case types.REREQUEST_REVIEW_FAILURE: {
      return {
        ...state,
        error: action.error,
        errorCode: action.errorCode,
        isLoading: false,
      };
    }
    case types.REREQUEST_REVIEW_SUCCESS: {
      return {
        ...state,
        isLoading: false,
      };
    }

    case types.PULL_REQUEST_STATIC_RESULTS_SUCCESS: {
      const { key, staticEngine, data } = action;
      return {
        ...state,
        staticResultsByKey: {
          ...state.staticResultsByKey,
          [key]: {
            ...(state.staticResultsByKey[key] || {}),
            [staticEngine]: data,
          },
        },
      };
    }
    case types.PULL_REQUEST_STATIC_RESULTS_REQUEST: {
      return { ...state, error: null, errorCode: null };
    }
    case types.PULL_REQUEST_STATIC_RESULTS_FAILURE: {
      return {
        ...state,
        error: action.error,
        errorCode: action.errorCode,
      };
    }

    case types.PULL_REQUEST_STATIC_TASK_ERROR_LOG_SUCCESS: {
      const { key, data } = action;
      return {
        ...state,
        isLoadingErrorLog: false,
        staticTaskErrorLogsByKey: {
          ...state.staticTaskErrorLogsByKey,
          [key]: data,
        },
      };
    }
    case types.PULL_REQUEST_STATIC_TASK_ERROR_LOG_REQUEST: {
      return {
        ...state,
        isLoadingErrorLog: true,
        error: null,
        errorCode: null,
      };
    }
    case types.PULL_REQUEST_STATIC_TASK_ERROR_LOG_FAILURE: {
      return {
        ...state,
        isLoadingErrorLog: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    }

    case types.PULL_REQUEST_DIFF_SUCCESS: {
      const { key, data } = action;
      let additions = 0;
      let deletions = 0;
      const files = data.files.map((file) => {
        // We want to exclude line counts from generated files in this total
        if (!file.is_generated) {
          additions += file.additions ? file.additions : 0;
          deletions += file.deletions ? file.deletions : 0;
        }
        return file;
      });
      const dependencyFiles = data.dependency_files;
      return {
        ...state,
        isLoadingDiff: false,
        diffByKey: {
          ...state.diffByKey,
          [key]: {
            ...data,
            files,
            dependencyFiles,
            additions,
            deletions,
          },
        },
      };
    }
    case types.PULL_REQUEST_DIFF_REQUEST: {
      return { ...state, isLoadingDiff: true, error: null, errorCode: null };
    }
    case types.PULL_REQUEST_DIFF_FAILURE: {
      return {
        ...state,
        isLoadingDiff: false,
        error: action.error,
        errorCode: action.errorCode,
      };
    }

    case types.PULL_REQUEST_COLLAPSED_COMMENTS_SUCCESS: {
      const { key, data, reviewKey } = action;
      return {
        ...state,
        collapsedComments: {
          ...state.collapsedComments,
          [reviewKey]: {
            ...state.collapsedComments[reviewKey],
            [key]: data,
          },
        },
      };
    }
    case types.PULL_REQUEST_COLLAPSED_STATIC_RESULTS_SUCCESS: {
      const { key, data, reviewKey } = action;
      return {
        ...state,
        collapsedStaticResults: {
          ...state.collapsedStaticResults,
          [reviewKey]: {
            ...state.collapsedStaticResults[reviewKey],
            [key]: data,
          },
        },
      };
    }
    case types.PULL_REQUEST_EXPAND_COMMENTS_SUCCESS: {
      const { reviewKey, key } = action;
      const collapsedComments = state.collapsedComments[reviewKey] || {};
      const updatedCollapsedComments = Object.keys(collapsedComments)
        .filter((commentKey) => commentKey !== key)
        .reduce((acc, key) => {
          acc[key] = collapsedComments[key];
          return acc;
        }, {});
      return {
        ...state,
        collapsedComments: {
          ...state.collapsedComments,
          [reviewKey]: {
            ...state.collapsedComments.reviewKey,
            ...updatedCollapsedComments,
          },
        },
      };
    }
    case types.PULL_REQUEST_EXPAND_STATIC_RESULTS_SUCCESS: {
      const { reviewKey, key } = action;
      const collapsedStaticResults =
        state.collapsedStaticResults[reviewKey] || {};
      const updatedCollapsedStaticResults = Object.keys(collapsedStaticResults)
        .filter((staticKey) => staticKey !== key)
        .reduce((acc, key) => {
          acc[key] = collapsedStaticResults[key];
          return acc;
        }, {});
      return {
        ...state,
        collapsedStaticResults: {
          ...state.collapsedStaticResults,
          [reviewKey]: {
            ...state.collapsedStaticResults.reviewKey,
            ...updatedCollapsedStaticResults,
          },
        },
      };
    }
    case types.PULL_REQUEST_SNOOZE_RESULT_SUCCESS: {
      const { filterUUID, key } = action;
      return {
        ...state,
        error: null,
        isTogglingSnooze: false,
        snoozedResultsByKey: {
          ...state.snoozedResultsByKey,
          [key]: {
            ...state.snoozedResultsByKey[key],
            lastCreatedFilterUUID: filterUUID,
          },
        },
      };
    }
    case types.PULL_REQUEST_SNOOZE_RESULT_FAILURE: {
      return { ...state, error: action.error, isTogglingSnooze: false };
    }
    case types.PULL_REQUEST_SNOOZE_RESULT_REQUEST: {
      return { ...state, error: null, isTogglingSnooze: true };
    }
    case types.PULL_REQUEST_UNDO_SNOOZE_RESULT_SUCCESS: {
      return { ...state, error: null, isTogglingSnooze: false };
    }
    case types.PULL_REQUEST_UNDO_SNOOZE_RESULT_FAILURE: {
      return { ...state, error: action.error, isTogglingSnooze: false };
    }
    case types.PULL_REQUEST_UNDO_SNOOZE_RESULT_REQUEST: {
      return { ...state, error: null, isTogglingSnooze: true };
    }
    case types.PULL_REQUEST_SNOOZED_RESULTS_SUCCESS: {
      const { data, key } = action;
      return {
        ...state,
        error: null,
        snoozedResultsByKey: {
          ...state.snoozedResultsByKey,
          [key]: { ...state.snoozedResultsByKey[key], data },
        },
      };
    }
    case types.PULL_REQUEST_SNOOZED_RESULTS_FAILURE: {
      return { ...state, error: action.error };
    }
    case types.PULL_REQUEST_SNOOZED_RESULTS_REQUEST: {
      return { ...state, error: null };
    }
    default:
      return state;
  }
};

export const getKey = (
  providerId,
  organizationSlug,
  projectName,
  reviewNumber
) => `${providerId}:${organizationSlug}:${projectName}:${reviewNumber}`;

export const getKeySha = (
  providerId,
  organizationSlug,
  projectName,
  reviewNumber,
  sha
) => `${providerId}:${organizationSlug}:${projectName}:${reviewNumber}:${sha}`;

export const getKeyUUID = (
  providerId,
  organizationSlug,
  projectName,
  reviewNumber,
  jobUUID
) =>
  `${providerId}:${organizationSlug}:${projectName}:${reviewNumber}:${jobUUID}`;

export const getCollapsedKey = (path, elementID) => `${path}:${elementID}`;

export const actions = {
  fetchPullRequest: (
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => ({
    type: types.PULL_REQUEST_REQUEST,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
  }),
  fetchPullRequestCommits: (
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => ({
    type: types.PULL_REQUEST_COMMITS_REQUEST,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
  }),
  fetchPullRequestEvents: (pullRequestUUID) => ({
    type: types.PULL_REQUEST_EVENTS_REQUEST,
    pullRequestUUID,
  }),
  fetchPullRequestComments: (
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => ({
    type: types.PULL_REQUEST_COMMENTS_REQUEST,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
  }),
  fetchPullRequestCommentSnippets: (
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => ({
    type: types.PULL_REQUEST_COMMENT_SNIPPETS_REQUEST,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
  }),
  fetchPullRequestReviews: (
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => ({
    type: types.PULL_REQUEST_REVIEWS_REQUEST,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
  }),
  fetchPullRequestStaticResults: (
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
    jobUUID,
    pullRequestUUID
  ) => ({
    type: types.PULL_REQUEST_STATIC_RESULTS_REQUEST,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
    jobUUID,
    pullRequestUUID,
  }),
  fetchPullRequestStaticResultSnippets: (
    sha,
    jobUUID,
    staticResults,
    batchSize,
    pullRequestUUID
  ) => ({
    type: types.PULL_REQUEST_STATIC_RESULTS_SNIPPETS_REQUEST,
    sha,
    jobUUID,
    staticResults,
    batchSize,
    pullRequestUUID,
  }),
  fetchPullRequestStaticTask: (
    sha,
    jobUUID,
    staticEngine,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
    pullRequestUUID
  ) => ({
    type: types.PULL_REQUEST_STATIC_TASK_REQUEST,
    sha,
    jobUUID,
    staticEngine,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
    pullRequestUUID,
  }),
  restartStaticJob: (
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => ({
    type: types.RESTART_STATIC_JOB_REQUEST,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
  }),
  fetchStaticTaskErrorLog: (job, task) => ({
    type: types.PULL_REQUEST_STATIC_TASK_ERROR_LOG_REQUEST,
    job,
    task,
  }),
  fetchPullRequestDiff: (
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
    sha,
    baseSha
  ) => ({
    type: types.PULL_REQUEST_DIFF_REQUEST,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
    sha,
    baseSha,
  }),
  collapseInlineElement: (
    element,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => ({
    type: types.PULL_REQUEST_COLLAPSE_ELEMENT_REQUEST,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
    element,
  }),
  expandInlineElement: (
    element,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => ({
    type: types.PULL_REQUEST_EXPAND_ELEMENT_REQUEST,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
    element,
  }),
  snoozeStaticResult: (
    pullRequestUUID,
    path,
    fingerprint,
    engine,
    severity,
    issueName,
    displayName
  ) => ({
    type: types.PULL_REQUEST_SNOOZE_RESULT_REQUEST,
    pullRequestUUID,
    path,
    fingerprint,
    engine,
    severity,
    issueName,
    displayName,
  }),
  undoSnoozeStaticResult: (pullRequestUUID, filterUUID) => ({
    type: types.PULL_REQUEST_UNDO_SNOOZE_RESULT_REQUEST,
    pullRequestUUID,
    filterUUID,
  }),
  fetchSnoozedStaticResults: (pullRequestUUID) => ({
    type: types.PULL_REQUEST_SNOOZED_RESULTS_REQUEST,
    pullRequestUUID,
  }),
  rerequestReview: (
    organization,
    project,
    reviewNumber,
    pullRequestUUID,
    status
  ) => ({
    type: types.REREQUEST_REVIEW_REQUEST,
    organization,
    project,
    reviewNumber,
    pullRequestUUID,
    status,
  }),
};

export const selectors = {
  pullRequestForOrgAndRepo: (
    state,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => {
    return state.pullRequests.byKey[
      getKey(providerId, organizationSlug, projectName, reviewNumber)
    ];
  },
  pullRequestCommitsForOrgAndRepo: (
    state,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => {
    return state.pullRequests.commitsByKey[
      getKey(providerId, organizationSlug, projectName, reviewNumber)
    ];
  },
  pullRequestEventsByUUID: (state, pullRequestUUID) => {
    return state.pullRequests.eventsByPullRequestUUID[pullRequestUUID];
  },
  pullRequestCommentsForOrgAndRepo: (
    state,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => {
    return state.pullRequests.commentsByKey[
      getKey(providerId, organizationSlug, projectName, reviewNumber)
    ];
  },
  pullRequestCommentSnippetsForOrgAndRepo: (
    state,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => {
    return state.pullRequests.commentSnippetsByKey[
      getKey(providerId, organizationSlug, projectName, reviewNumber)
    ];
  },
  pullRequestReviewsForOrgAndRepo: (
    state,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => {
    return state.pullRequests.reviewsByKey[
      getKey(providerId, organizationSlug, projectName, reviewNumber)
    ];
  },
  pullRequestStaticJobForOrgAndRepo: (
    state,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
    jobUUID = 'latest'
  ) => {
    return state.pullRequests.staticJobsByKey[
      getKeyUUID(
        providerId,
        organizationSlug,
        projectName,
        reviewNumber,
        jobUUID
      )
    ];
  },
  pullRequestStaticResultsForOrgAndRepo: (
    state,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
    jobUUID
  ) => {
    return state.pullRequests.staticResultsByKey[
      getKeyUUID(
        providerId,
        organizationSlug,
        projectName,
        reviewNumber,
        jobUUID
      )
    ];
  },
  pullRequestStaticResultsList: (
    state,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
    jobUUID
  ) => {
    const staticResults =
      state.pullRequests.staticResultsByKey[
        getKeyUUID(
          providerId,
          organizationSlug,
          projectName,
          reviewNumber,
          jobUUID
        )
      ];
    return staticResults
      ? union(
          ...Object.entries(staticResults).map(([engine, entries]) =>
            entries.map((entry) => {
              return { ...entry, engine };
            })
          )
        )
      : [];
  },
  pullRequestStaticResultsSnippetsForJob: (state, jobUUID) => {
    return state.pullRequests.staticResultsSnippetsByKey[jobUUID];
  },
  pullRequestStaticTaskErrorLog: (state, job, task) => {
    return state.pullRequests.staticTaskErrorLogsByKey[
      `${job.uuid}:${task.engine}`
    ];
  },
  pullRequestDiffForOrgAndRepo: (
    state,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber,
    sha
  ) => {
    return state.pullRequests.diffByKey[
      getKeySha(providerId, organizationSlug, projectName, reviewNumber, sha)
    ];
  },
  pullRequestSnoozedStaticResults: (state, pullRequestUUID) => {
    return state.pullRequests.snoozedResultsByKey[pullRequestUUID];
  },
  pullRequestLastSnoozeFilterUUID: (state, pullRequestUUID) => {
    const snoozedResults = state.pullRequests.snoozedResultsByKey || {};
    const snoozedResultsByKey = snoozedResults[pullRequestUUID]
      ? snoozedResults[pullRequestUUID]
      : {};
    return snoozedResultsByKey.lastCreatedFilterUUID;
  },
  pullRequestCollapsedComments: (
    state,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => {
    return state.pullRequests.collapsedComments[
      getKey(providerId, organizationSlug, projectName, reviewNumber)
    ];
  },
  pullRequestCollapsedStaticResults: (
    state,
    providerId,
    organizationSlug,
    projectName,
    reviewNumber
  ) => {
    return state.pullRequests.collapsedStaticResults[
      getKey(providerId, organizationSlug, projectName, reviewNumber)
    ];
  },
};
